import {Component, Input} from '@angular/core';
import {ActionTypeSelectStrategyService} from '@app/services/action-type-select-strategy/action-type-select-strategy.service';
import {DcpBundleTemplate, TransactionListCta, TransactionType} from '@dcp/configurator';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Product} from '@spartacus/core';

@Component({
  selector: 'dcp-cta-info-page-cta-link',
  templateUrl: './cta-info-page-cta-link.component.html',
  styleUrls: ['./cta-info-page-cta-link.component.scss']
})
export class CtaInfoPageCtaLinkComponent {

  @Input() slmTransactionType: TransactionListCta;
  @Input() bundleTemplate: DcpBundleTemplate;
  @Input() product: Product;

  constructor(
    private actionTypeSelectStrategyService: ActionTypeSelectStrategyService,
    private activeModal: NgbActiveModal,
  ) {
  }

  executeAction(): void {
    this.activeModal.close();
    const actionTypeContext = this.actionTypeSelectStrategyService.selectStrategy(
      {actionType: this.slmTransactionType.actionType} as TransactionType,
      this.product,
      this.slmTransactionType,
      this.bundleTemplate,
    );
    actionTypeContext.exec();
  }
}
